export default __webpack_public_path__ + "static/media/client-6.8a5821e9.png";